import { GiftOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import NotificationBell from './NotificationBell';
import RedeemBenefitModal from './RedeemBenefitModal';

export type SiderTheme = 'light' | 'dark';

export { NotificationBell };

/** 顶栏礼物图标：点击打开权益兑换弹窗（替代原 Question 入口） */
export const Question: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label="兑换权益"
        onClick={() => setOpen(true)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          padding: 10,
          fontSize: 18,
          cursor: 'pointer',
          color: '#fff',
          border: 'none',
          background: 'transparent',
        }}
      >
        <GiftOutlined />
      </button>
      <RedeemBenefitModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};
